import { Plugin } from '@nuxt/types'
import { RedirectError } from '../store/store-errors'

const plugin: Plugin = async (context, _inject) => {
  if (context.isClient) {
    // store를 사용하지 않을 경우 제외
    if (!context.store) {
      return
    }

    try {
      await context.store.dispatch('nuxtClientInit', context)
    } catch (e) {
      if (RedirectError.isEquals(e)) {
        await context.$ustra.nuxt.onReady(() => {
          context.redirect({ path: e.args.path, query: e.args.query })
        })

        // #region old code
        // @ts-ignore
        // window.__auth_redirect_error = e
        // context.app.router.beforeEach((_to, _from, next) => {
        //   // @ts-ignore
        //   const e = window.__auth_redirect_error
        //   console.log('window.__auth_redirect_error', e)
        //   if (e) {
        //     // @ts-ignore
        //     window.__auth_redirect_error = undefined
        //     next(e.args.path)
        //   } else {
        //     next()
        //   }
        //   // return context.redirect({ path: e.args.path, query: e.args.query })
        // })
        // @ts-ignore
        // window.onNuxtReady(() => {
        //   context.redirect({ path: e.args.path, query: e.args.query })
        //   // window.$nuxt.$router.replace(e.args.path, e.args.query)
        // })
        // context.redirect({ path: (e as RedirectError).args.path })
        // #endregion
      }
      // 인증 관련 오류 처리
      // @ts-ignore
      else if (context.$auth && context.$auth.isAuthenticationError(e)) {
        // 인증 관련 오류는 plugin에 의해 처리되므로 무시함.
      }
    }
  }
}

export default plugin
